import { useEffect, useState, useContext } from 'react';
import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import CircularProgress from '@mui/material/CircularProgress';
// material
import { Card, CardHeader, Box, Typography, Alert } from '@mui/material';
// context
import { ReportEntryContext } from '../../../contexts/Report/Entry';
// halpers
import { getTimeZoneGTM, getTimeZoneDate } from '../../../helpers/Util';
//
import { BaseOptionChart } from '../../charts';

// ----------------------------------------------------------------------

export default function AppTimeEntriesChart() {
  const [chartLabels, setChartLabels] = useState([]);
  const [chartData, setChartData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const {
    entriesPerTime,
    eventDate,
    start,
    end,
    isLoading: isLoadingTimeEntries,
    hasError: hasErrorTimeEntries
  } = useContext(ReportEntryContext);

  useEffect(() => {
    const setData = async () => {
      try {
        const chartLabels = entriesPerTime.perTime.map((entry) => entry._id);
        const chartData = [
          {
            name: 'Entries',
            data: entriesPerTime.perTime.map((entry) => entry.quantity)
          }
        ];

        setChartLabels(chartLabels);
        setChartData(chartData);
      } catch (err) {
        setHasError(true);
        console.error(err);
      }

      setIsLoading(false);
    };

    if (!isLoadingTimeEntries && !hasErrorTimeEntries) {
      setData();
    }
  }, [entriesPerTime, isLoadingTimeEntries, hasErrorTimeEntries]);

  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      type: 'line',
      height: 350,
      stacked: true
    },
    stroke: {
      curve: 'straight'
    },
    labels: [...chartLabels],
    xaxis: {
      labels: {
        formatter: (value) => {
          if (value) {
            return getTimeZoneDate({ date: value })
              .tz('Europe/Lisbon')
              .format('ddd, DD MMM, HH:mm');
          }
          return value;
        }
      }
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y}`;
          }
          return y;
        }
      }
    }
  });

  if (hasError || hasErrorTimeEntries) {
    return (
      <Alert severity="error">
        An error occurred while trying to load the daily sales — Please, try to refresh the page!
      </Alert>
    );
  }

  return (
    <Card>
      <CardHeader
        title="Entries Time"
        subheader={`${!((start && end) || eventDate) ? 'Last 30 days' : ''} (GTM${getTimeZoneGTM({
          date: new Date()
        })})`}
      />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        {isLoading || isLoadingTimeEntries ? (
          <Typography align="center" variant="h3">
            <CircularProgress size={30} color="inherit" />
          </Typography>
        ) : (
          <ReactApexChart type="line" series={chartData} options={chartOptions} height={364} />
        )}
      </Box>
    </Card>
  );
}
